import { render, staticRenderFns } from "./WordSelectQuestionInput.vue?vue&type=template&id=3501bb41&scoped=true"
import script from "./WordSelectQuestionInput.vue?vue&type=script&lang=js"
export * from "./WordSelectQuestionInput.vue?vue&type=script&lang=js"
import style0 from "./WordSelectQuestionInput.vue?vue&type=style&index=0&id=3501bb41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501bb41",
  null
  
)

export default component.exports